import { Controller } from "@hotwired/stimulus"

// The round's drivers dialog (#8439, prototype v1.10). The list is picked and
// saved in one go, so the dialog only has to open and close: the multi-select
// is server-rendered with the round's drivers already selected, and the form
// posts on its own.
export default class extends Controller {
  static targets = ["dialog"]

  open(event) {
    event.preventDefault()
    this.dialogTarget.showModal()
  }

  close(event) {
    event.preventDefault()
    event.target.closest("dialog").close()
  }
}
